const VehiculeStep = {
  STOCK: 'stock',
  EN_ATTENTE_DE_DESTOCKAGE: 'en_attente_de_destockage',
  SORTIE: 'sortie',
}

export default VehiculeStep
